
import { oz } from '@weft/utils';
import { PASSWORD_PATTERN } from './password-schema-consts';

export const PasswordSchema = oz.string()
  .min(8, 'Must be at least 8 characters long')
  .regex(/[A-Z]/, 'Must contain an uppercase letter')
  .regex(/[a-z]/, 'Must contain a lowercase letter')
  .regex(/[0-9]/, 'Must contain a number')
  .regex(PASSWORD_PATTERN, 'Must contain a special character')
  .openapi('Password');

export type Password = oz.infer<typeof PasswordSchema>;
